<script lang="ts">
  import type { ISelectDataItem } from '../../types'

	import { fade } from 'svelte/transition'
  import { clickOutside } from './../../../../../../../helpers/index.js'
  
  import MultipleCheckbox from '../MultipleCheckbox/MultipleCheckbox.svelte'

  export let value: any
  export let title: string
  export let items: ISelectDataItem[]
  export let type: 'radio' | 'checkbox' = 'radio'

  let isShowItems: boolean = false
</script>

<div class="form-group">
  <div class="title">{title}</div>

  <div 
    class="select" 
    on:click={() => isShowItems = !isShowItems} 
    use:clickOutside
    on:click_outside={() => isShowItems = false}
  >
    {#if Array.isArray(value)}
      {#if value.length}
        <div class="select-value">{ [...value].map(({ title }) => title).join(', ') }</div>
      {:else}
        <div class="select-value grey">Заполни тут...</div>
      {/if}
    {:else}
      {#if value}
        <div class="select-value">{value.title}</div>
      {:else}
        <div class="select-value grey">Заполни тут...</div>
      {/if}
    {/if}

    {#if isShowItems}
      <div 
        class="select-items" 
        on:click|stopPropagation 
        transition:fade
      >
        {#each items as item (item.pk)}
          {#if type === 'radio'}
            <div class="radio-button">
              <input 
                type="radio" 
                id={item.pk.toString()}
                value={item}
                bind:group={value}
                on:click={() => isShowItems = false} 
              >
              <label for={item.pk.toString()}>
                {item.title}
              </label>
            </div>
          {/if}

          {#if type === 'checkbox'}
            <div class="checkbox-button">
              <MultipleCheckbox 
                label={item.title} 
                value={item} 
                bind:bindGroup={value} 
              />
            </div>
          {/if}
        {/each}
      </div>
    {/if}

    {#if Array.isArray(value)}
      {#if value.length}
        <i class="icon-cross" on:click|stopPropagation={() => value.length = 0} />
      {:else}
        <i class="icon-chevron-right" style:transform={`rotate(${isShowItems ? '90deg' : '0'})`} />
      {/if}
    {:else}
      {#if value}
        <i class="icon-cross" on:click|stopPropagation={() => value = null} />
      {:else}
        <i class="icon-chevron-right" style:transform={`rotate(${isShowItems ? '90deg' : '0'})`} />
      {/if}
    {/if}
  </div>
</div>

<style lang="scss">
  i {
    position: absolute;
    right: 20px;
    top: 13px;
    font-size: 10px;
    transition: transform .3s;
    height: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .checkbox-button {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;
    }
  }
  
  .radio-button {
    margin-bottom: 24px; 
    &:last-child {
      margin-bottom: 0;
    }
  }
  [type="radio"] {
    &:checked,
    &:not(:checked) {
      position: absolute;
      left: -9999px;
      & + label {
        position: relative;
        padding-left: 37px;
        cursor: pointer;
        line-height: 20px;
        display: inline-block;
        color: #666;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          top: 0;
          width: 18px;
          height: 18px;
          border: 1px solid #ddd;
          border-radius: 100%;
          background: white;
          border: 2px solid #E0E8F6;
        }
        &::after {
          content: '';
          width: 8px;
          height: 8px;
          background: white;
          position: absolute;
          left: 11px;
          top: 11px;
          transform: translate(-50%,-50%) !important;
          border-radius: 100%;
          -webkit-transition: all 0.2s ease;
          transition: all 0.2s ease;
        }
      }
    }
    &:checked + label {
      &:before {
        background: #2B50ED;
        border-color: #2B50ED;
      }
      &:after {
        opacity: 1;
        -webkit-transform: scale(1);
        transform: scale(1);
      }
    }
    &:not(:checked) + label:after {
      opacity: 0;
      -webkit-transform: scale(0);
      transform: scale(0);
    }
  }

  .form-group {
    margin-bottom: 16px;
  }

  .title {
    color: #30333D;
    font-size: 16px;
    font-weight: 600;
    line-height: 23px;
    letter-spacing: 0em;
    margin-bottom: 8px;
  }

  .select {
    position: relative;
    cursor: pointer;
  }

  .select-items {
    overflow-y: scroll;
    z-index: 999999999;
    max-height: 200px;
    width: 100%;
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    box-shadow: 0px 2px 8px 0px #10107A29;
    position: absolute;
    margin-top: 8px;
    background-color: white;
  }

  .select-value {
    border: 1px solid #B6C8F9;
    padding: 12px;
    background-color: white;
    outline: none;
    border-radius: 4px;
    width: 100%;
    box-sizing: border-box;
    font-size: 16px;
    line-height: 23px;
    letter-spacing: 0em;
    color: #30333D;
    min-height: 49px;
    font-weight: normal;

    &.grey {
      color: #5A5F6D99;
    }

    &::-ms-expand {
      display: none !important;
    }

    &::placeholder {
      color: #5A5F6D99;
      font-size: 16px;
      line-height: 23px;
      letter-spacing: 0em;
    }
  }
</style>